import React from "react";
import { useSelector } from "react-redux";

const FoodItems = () => {
  const { category_all } = useSelector((store) => store.category);
  return (
    <>
      <div className="map_view_btn">Assign Categories</div>
      <div className="menu_container">
        <div className="menu_main_box">
          <div className="menu_main_box_header">
            <div className="mn_hd_box">
              <div className="mn_hd_titl">
                <h5>Categories</h5>
              </div>
              <div className="mn_hd_icon_box"></div>
            </div>
          </div>
          <div className="menu_list_box">
            <ul>
              {category_all &&
                category_all.map((data, index) => (
                  <li className={index === 0 ? "active_item" : ""} key={index}>
                    <span className="item_name">{data.name}</span>
                    <span className="item_ed_icon"></span>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div className="menu_main_box">
          <div className="menu_main_box_header">
            <div className="mn_hd_box">
              <div className="mn_hd_titl">
                <h5>Asian</h5>
              </div>
              <div className="mn_hd_icon_box"></div>
            </div>
          </div>
          <div className="menu_list_box">
            <ul>
              <li className="">
                <span className="item_name">Asian</span>
                <span className="item_ed_icon"></span>
              </li>
              <li>
                <span className="item_name">Asian</span>
                <span className="item_ed_icon"></span>
              </li>
              <li>
                <span className="item_name">Asian</span>
                <span className="item_ed_icon"></span>
              </li>
              <li>
                <span className="item_name">Asian</span>
                <span className="item_ed_icon"></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default FoodItems;
